import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConsoleHomeService } from 'src/app/core/services/console-home.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { path } from 'src/environments/config';
import { SelectWorkspaceComponent } from '../nav-bar/select-workspace/select-workspace.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'vcp-outlet',
  templateUrl: './outlet.component.html',
  styleUrls: ['./outlet.component.scss'],
})
export class OutletComponent implements OnInit {
  closeAllPanel;
  sidebarList = [
    { route: 'home', type: 'home' },
    { route: 'invited-workspace', type: 'workspace' },
    { route: 'public-workspace', type: 'workspace' },
    { route: 'workspace', type: 'workspace' },
    { route: 'notification-settings', type: 'profile' },
    { route: 'profile', type: 'profile' },
    { route: 'activity-logs', type: 'profile' },
    { route: 'notification-center', type: 'notification-center' },
    { route: 'app-management', type: 'applications'},
    { route: 'create-app', type: 'create-app'}
    // { route: 'account-management', type: 'account' },
  ];
  selectedModule;
  userSubscription;
  userData;
  loaderSubscription;
  loader = false;
  workspaceList: any = [];
  selectedWorkspace: any;
  selectedworskapceName: any;
  btnLoader: boolean;
  account: any;
  switchedSelectedWorkspace: any;
  appSubscription: any;
  module: any;

  constructor(
    readonly us: UtilityService,
    private router: Router,
    private profileService: ProfileService,
    private chs: ConsoleHomeService,
    private dialog: MatDialog,
    private renderer:Renderer2
  ) {

    this.renderer.listen('window', 'click',(e:Event)=>{
      this.closeAllPanel = false;
      setTimeout(()=>{
        this.closeAllPanel = true;
      },100);
      // let popupMenu1 = document.getElementById("popupMenu1");
      // if(popupMenu1){
      // }
    });
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.getHeader(val.url);
      }
    });
    this.getProfile();
  }


  ngOnInit(): void {
    this.getAccountWorkspace();
    this.userSubscription = this.profileService.user.subscribe((value) => {
      if (value && value['type'] == 'update') {
        this.userData = value['data'];
      }
      this.us.userData = value;
    });
    this.loaderSubscription = this.us.loader.subscribe((value) => {
      this.loader = value ? true : false;
    });

    this.us.childEmitter.subscribe(res => {
      if(res == false){
        this.us.isNotificationPanelVisible = false;
        this.us.NotificationVisibilityEmitter.next(res);
        console.log('outlet se change hua',this.us.isNotificationPanelVisible)
      }
    })
  }

//
  ngOnChanges(): void {
    this.us.childEmitter.subscribe(res => {
      if(res == false){
        this.us.isNotificationPanelVisible = false;
        this.us.NotificationVisibilityEmitter.next(res);
        console.log('ngon change from outlet',this.us.isNotificationPanelVisible)
      }
    })
  }


  getProfile() {
    this.us.showLoader();
    this.profileService.getUserById().subscribe((res) => {
      this.us.hideLoader();
      if (res && res['code'] === 'success') {
        if (res['data']['mobileNumberCode'] === '+91') {
          res['data']['mobileNumberCode'] = 'IN';
        }
        this.userData = res['data'];
        this.profileService.setUserData(this.userData);
        this.profileService.userSubject({ type: 'get', data: this.userData });
      }
    });
  }

  leftBarClose(){
    const leftmenu = document.getElementById('leftmenu');
    leftmenu.classList.remove('expanded');
    // document.getElementById('expTool').innerText = 'Expand';
    this.us.isLeftMenuOpen = false;
  }


  getHeader(url) {
    let path = url.split('/')[1];
    if (!path) {
      this.selectedModule = this.sidebarList[0];
      this.module = this.selectedModule.type;
      return;
    }
    if (path.includes('?')) {
      path = path.split('?')[0];
    }
    this.selectedModule = this.sidebarList.find((ele) => ele.route === path);
    this.module = this.selectedModule.type;
  }

  changeMiddleClass(val: boolean) {
    const main = document.getElementById('main');
    if (this.us.isLeftMenuOpen && this.us.isRightMenuOpen) {
      main.classList.add('remove-gutter');
    } else if (this.us.isLeftMenuOpen || this.us.isRightMenuOpen) {
      main.classList.remove('remove-gutter');
    } else if (!this.us.isLeftMenuOpen || !this.us.isRightMenuOpen) {
      main.classList.remove('remove-gutter');
    }
    if (!this.us.isLeftMenuOpen && !this.us.isRightMenuOpen) {
      main.classList.remove('remove-gutter');
    }
  }

  getAccountWorkspace() {
    let data = {
      userId: this.us.getUserId(),
    };
    const query = this.us.getObjToQueryParam(data);
    this.chs.getAccountWorkspaceList(query).subscribe((res) => {
      if (res && res['code'] === 'success') {
        this.workspaceList = res['data'];
        this.us.workspaceList = res['data'];
        this.getDefaultWorkspace();
      }
    });
  }

  getDefaultWorkspace() {
    const workspaceHierarchy = this.us.getWorkspaceAccessLevel();
    if (workspaceHierarchy) {
      let ele = this.workspaceList.find(
        (ele) => ele.workspaceHierarchy == workspaceHierarchy
      );
      if(!ele){
        ele = this.workspaceList[0];
      }
      if (ele) {
        this.selectedWorkspace = workspaceHierarchy;
        this.selectedworskapceName = ele.workspaceName;
        console.log('ele for worspace',ele)
        this.us.setCookie('WORKSPACE_NAME',ele.workspaceName);
        this.us.setCookie('WORKSPACE_ID',ele.workspaceId);
        this.us.setCookie('DEFAULT_ACCOUNT_USER_ROLE',ele.userRole);
        this.us.setCookie('DEFAULT_ACCOUNT_NAME',ele.accountName);
        this.us.setCookie('DEFAULT_ACCOUNT_ID',ele.accountId);
        this.us.setCookie('DEFAULT_ACCOUNT_HIERARCHY',ele.accountHierarchy);
        this.us.orgID = ele['workspaceId'];
        this.us.orgname = ele['workspaceName'];
      } else {
        let defaultworkspace = this.workspaceList.find(
          (ele) => ele.accountId == this.us.getDefaultAccountId()
        );
        if(defaultworkspace){
          this.selectedWorkspace = defaultworkspace.workspaceHierarchy;
          this.selectedworskapceName = defaultworkspace.workspaceName;
          this.us.orgID = defaultworkspace.workspaceId;
          this.us.orgname = defaultworkspace.workspaceName;
        }
        this.setPrefrence(defaultworkspace);
      }
    }
  }

  setPrefrence(dws){
    if (this.us.getWorkspaceAccessLevel()) {
      let accessLevelws = this.us.getWorkspaceAccessLevel();
      if (accessLevelws === dws.workspaceHierarchy) {
        return;
      }
    }
    const preferences = [
      {
        name: 'ACCESS_LEVEL',
        value: dws.workspaceHierarchy,
      },
    ];
    this.btnLoader = true;
    this.chs.savePreference(preferences).subscribe((res) => {
      this.btnLoader = false;
      if (res && res.code === 'success') {
        let msg = {
          id: dws.workspaceHierarchy,
          env: path
        }
        this.us.setCookie('WORKSPACE_NAME',dws.workspaceName);
        this.us.broadcast(msg);
        this.chs.setConsoleSubject({
          action: 'refresh',
          workspace: dws,
        });
      }
    });
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.loaderSubscription.unsubscribe();
  }

  //new code for opening select workspace component

  openDialog(event) {
    this.us.childEmitter.next(false);
    this.workspacePopup(event);
  }

  workspacePopup(event) {
    const rects = event.detail['getClientRects']();
    let x = rects[0].x + rects[0].width / 2 - 10;
    let y = rects[0].y + rects[0].height;
    console.log('x', x);
    console.log('y', y);
    const dialogRef = this.dialog.open(SelectWorkspaceComponent, {
      maxWidth: 'inherit',
      width: '344px',
      panelClass: ['switch-workspace'],
      data: {
        list: this.handleWorkspaceList(this.workspaceList),
      },
    });
    this.appSubscription = this.chs.consoleSubject.subscribe((value) => {
      if (value && value['action'] == 'refresh') {
        this.selectedWorkspace = value['workspace'].workspaceHierarchy;
        if (this.selectedWorkspace) {
          let ele = this.workspaceList.find(
            (ele) => ele.workspaceHierarchy == this.selectedWorkspace
          );
          if (ele) {
            this.selectedworskapceName = ele.workspaceName;
            this.us.setWorkSpaceName(this.selectedworskapceName);
          }
        }
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
    const ele = document.getElementsByClassName('switch-workspace')[0] as any;
    ele.style.top = y + 'px';
    ele.style.left = x + 'px';
  }

  handleWorkspaceList(workspaces) {
    let workspaceList = [];
    let uniqueAccountId = [...new Set(workspaces.map((ele) => ele.accountId))];
    uniqueAccountId.forEach((accountId) => {
      let account = workspaces.find((ele) => ele.accountId == accountId);
      let accountObj = {
        accountId: account.accountId,
        accountName: account.accountName,
        accountHierarchy: account.accountHierarchy,
        workspaces: workspaces.filter((ele) => ele.accountId === accountId),
      };
      workspaceList.push(accountObj);
    });
    return workspaceList;
  }

}
